module.exports = __webpack_public_path__ + "static/img/header_bg5.eedebff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/header/header_bg5.png
// module id = T4p5
// module chunks = 1